
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/weekly",
      function () {
        return require("private-next-pages/weekly/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/weekly"])
      });
    }
  